import { Provider } from "@angular/core";
import { DialogService, DynamicDialogModule, DynamicDialogRef } from "primeng/dynamicdialog";
import { PopupService } from "./services/confirmation-popup/popup.service";

export function provideConfirmationDialog(): Provider[] {
  return [DialogService, PopupService, DynamicDialogRef, DynamicDialogModule];
}

export * from "./components/alert-dialog/alert-dialog.component";
export * from "./components/confirmation-dialog/confirmation-dialog.component";
